// extracted by mini-css-extract-plugin
module.exports = {"PageTransitionSpinner":"PageTransitionSpinner_PageTransitionSpinner__vKy0j"};